<template>
  <div class="home">
    <vue-particles
      class="vue-particles-cust"
      color="#3c5b8c"
      linesColor="#17a2b8"
      :particlesNumber="70"
      :particleSize="5"
      :lineOpacity="0.4">
      </vue-particles>
    <div class="logo-center" :style="{ backgroundImage: `url('${require('@/assets/img/logo-outline.webp')}')` }"></div>
    <h1 style="width: 100%; position: absolute; bottom: 20%; text-align: center;">Wibowo Devs</h1>
    <h3 style="width: 100%; position: absolute; bottom: 12%; text-align: center;">I <vue-typer :text="teks"></vue-typer></h3>
  </div>
</template>

<script>
import { VueTyper } from 'vue-typer'

export default {
  components: {
    VueTyper
  },
  data: function () {
    return {
      teks: [
        'am a web developer',
        'am a graphic designer',
        'love Vue.js',
        'am an occasional cyclist'
      ]
    }
  }
}
</script>
